export const GET_QUIZBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    quizBlock(id: "${id}", preview: ${preview}) {
      sys{id}
      quizType
      quizStartDate
      quizEndDate
      startViewTitle
      startViewText
      startViewButtonText
      startViewIvImage
      questionAreaCollection {
        total
        items {
          ... on QuizQuestionBlock {
            question
            answerOne
            answerTwo
            answerThree
            answerFour
            correctAnswer
            ivImage
            feedbackCorrectAnswer
            feedbackWrongAnswer
          }
        }
      }
      resultInsufficientMessage
      resultBronzeMessage
      resultSilverMessage
      resultGoldMessage
      resultBronzeIvImage
      resultSilverIvImage
      resultGoldIvImage
      resultPageContactButtonText
      resultPageConclusionButtonText
    }
  }
`;
